import React from 'react';
import { StaticQuery, graphql } from 'gatsby';
import styled from '@emotion/styled';
import cx from 'classnames';
import orderBy from 'lodash/orderBy';
import { view } from 'react-easy-state';
import AnchorLink from 'react-anchor-link-smooth-scroll';
import Sticky from 'react-sticky-el';
import { rgba, lighten } from 'polished';
// import { Scrollbars } from 'react-custom-scrollbars';

import { baseStore } from '../store';

import { getNodes } from '../utils';
import { colors, baseFont } from '../styles/theme';

import LLLLogo from '../images/lll.svg';
import mq from '../styles/mq';
import { HiddenText } from './elements';

export default class TopLinks extends React.Component {
  render() {
    return (
      <StaticQuery
        query={graphql`
          query TopLinksQuery {
            categories: allWordpressWpFriendCategories(filter: { name: { ne: "Uncategorized" } }) {
              edges {
                node {
                  id
                  wordpress_id
                  slug
                  name
                  count
                }
              }
            }
            news: allWordpressWpNewsVideos {
              edges {
                node {
                  acf {
                    video
                  }
                }
              }
            }
          }
        `}
        render={data => <Links data={data} />}
      />
    );
  }
}

const renderThumb = ({ style, ...props }) => {
  const thumbStyle = {
    display: 'none',
  };
  return <div style={{ ...style, ...thumbStyle }} {...props} />;
};

const Links = view(({ data }) => {
  const categories = orderBy(getNodes(data.categories), 'count', 'desc');
  const news = orderBy(getNodes(data.news));
  return (
    <Sticky
      css={{
        padding: '0.5rem 0',
        borderTop: `1px solid ${colors.pr.gray200}`,
        // transition: 'all 0.3s ease',
        zIndex: 500,
        background: rgba('#fff', 0.95),
      }}
    >
      <section
        className="section"
        css={{
          paddingTop: 0,
          paddingBottom: 0,
          '@media (max-width: 480px)': {
            padding: 0,
          },
        }}
      >
        <nav
          className="container"
          css={{
            lineHeight: 1,
            // overflowX: 'auto',
            // overflowY: 'hidden',
            // margin: '0 -1.5rem',
            // padding: '0 1.5rem'
          }}
        >
          <LinksUl>
            <li>
              <AnchorLink
                href="#top"
                css={{ paddingTop: '0 !important', paddingBottom: '0 !important' }}
              >
                <LLLLogo css={{ height: '2em' }} />
                <HiddenText>Back To Top</HiddenText>
              </AnchorLink>
            </li>

            {categories.map(cat => (
              <li key={cat.id} className={cx({ active: baseStore.section === cat.slug })}>
                <AnchorLink href={`#${cat.slug}`} offset={() => 60}>
                  {cat.name}s
                </AnchorLink>
              </li>
            ))}

            <li className={cx({ active: baseStore.section === 'videos' })}>
              <AnchorLink href="#videos" offset={() => 60}>
                Videos
              </AnchorLink>
            </li>

            <li className={cx({ active: baseStore.section === 'albums' })}>
              <AnchorLink href="#albums" offset={() => 60}>
                Albums
              </AnchorLink>
            </li>

            <li>
              <CTA
                href={news[0].acf.video}
                target="_blank"
                rel="noopener noreferrer"
                onClick={baseStore.openVideo}
                className="cta"
              >
                What&rsquo;s New
              </CTA>
            </li>

            {/* <div>
              <a href="https">Mahabbah Mall</a>
            </div> */}
          </LinksUl>
        </nav>
      </section>
    </Sticky>
  );
});

const LinksUl = styled.ul`
  display: flex;
  justify-content: space-between;
  flex-wrap: nowrap;
  align-items: center;
  fontfamily: 'IBM Plex Mono', ${baseFont};
  font-size: 0.9rem;
  font-weight: 700;
  letter-spacing: 1px;
  text-transform: uppercase;
  margin: 0 -1.5rem -17px;
  padding: 0 0 17px;
  overflow-y: hidden;
  ${mq({
    overflowX: ['scroll', 'scroll', 'auto'],
  })}

  li {
    position: relative;

    &:after {
      content: '';
      width: 2rem;
      height: 0;
      position: absolute;
      bottom: 0;
      left: 1rem;
      background: ${colors.primary};
      opacity: 0;
      border-radius: 10px;
      transition: all 0.3s ease;
    }
  }

  li.active {
    &:after {
      height: 4px;
      opacity: 1;
    }
    a {
      color: ${colors.primary};
    }
  }

  a {
    display: flex;
    align-items: center;
    margin: 0 1rem;
    padding: 0.75rem 0;
    color: ${colors.pr.gray600};

    &:hover {
      color: ${colors.primary};
    }
  }

  @media (max-width: 480px) {
    margin: 0;
    padding: 0;
    font-size: 12px;

    ${'' /* a {
      display: block;
    } */}
  }
`;

const CTA = styled.a`
  margin-left: 0.5rem;
  padding: 0.75rem 1rem !important;
  border-radius: 5rem;
  background: linear-gradient(to bottom, ${lighten(0.1, colors.primary)}, ${colors.primary});
  color: #fff !important;
  white-space: nowrap;

  &:hover {
    background: linear-gradient(to bottom, ${lighten(0.2, colors.primary)}, ${colors.primary});
  }
`;
